import { List } from 'immutable';

// The helpers in this file are intended to smooth over the rough edges of "do I have an immutable value or not"

export const getAt = <T>(collection: List<T> | ReadonlyArray<T>, index: number): T | undefined =>
  List.isList(collection) ? collection.get(index) : collection[index];

export const reduce = <T, R>(
  collection: List<T> | ReadonlyArray<T>,
  start: R,
  accumulator: (result: R, item: T) => R,
): R => (List.isList(collection) ? collection.reduce(accumulator, start) : collection.reduce(accumulator, start));

export const ensureArray = <T>(collection: List<T> | Array<T>): Array<T> =>
  List.isList(collection) ? collection.toArray() : collection;

export const getLength = <T>(collection: List<T> | Array<T> | null | undefined): number => {
  if (!collection) return 0;

  return List.isList(collection) ? collection.size : collection.length;
};
